/**
 * Deloitte brand theme — logos, background images, and colors.
 * Mirrors the shape of theme.comply.js so the two are interchangeable.
 */
import sidebarLogoExpanded from "../../../../assets/brands/deloitte/sidebar-logo.svg";
import sidebarLogoCollapsed from "../../../../assets/brands/deloitte/sidebar-logo.svg";
import loginBackground from "../../../../assets/brands/deloitte/login-background.png";
import loginLogo from "../../../../assets/brands/deloitte/login-logo.svg";
import favicon from "./favicon.ico";

export const deloitteTheme = {
  name: "deloitte",
  title: "Extractor - Deloitte",
  favicon,
  logos: {
    sidebarExpanded: sidebarLogoExpanded,
    sidebarCollapsed: sidebarLogoCollapsed,
    sidebarAlt: "Deloitte",
    login: loginLogo,
  },
  images: {
    loginBackground,
  },
  colors: {
    sidebarBackground: "#000000",
    sidebarText: "#ffffff",
    sidebarHoverBackground: "rgb(41, 43, 44)",
    sidebarActiveBackground: "#121212",
    sidebarActiveText: "#86bc25",
    primary: "#98ca49",
    secondary: "#000000",
    buttonPrimaryBackground: "#000000",
    buttonPrimaryText: "#ffffff",
    buttonOutlineBackground: "transparent",
    buttonOutlineText: "#98ca49",
    buttonOutlineBorder: "#98ca49",
  },
};

export default deloitteTheme;
